import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'test-modal-content',
  templateUrl: './test-modal.component.html'
})
export class TestModalContent {
  @Input() name;
  @Input() user;

  constructor(public activeModal: NgbActiveModal) { }

}
